// extracted by mini-css-extract-plugin
export var container = "_gn-0";
export var segment = "_gn-2";
export var segmentActive = "_gn-3";
export var track = "_gn-1";